/**
 * useSkills Hook
 *
 * Thin wrapper over useWorkflows pre-filtered by usageType='skill'.
 */

import { useWorkflows } from '@/modules/workflows/hooks';
import type { WorkflowQuery, WorkflowStatus } from '@/modules/workflows/types';

export interface UseSkillsOptions {
  status?: WorkflowStatus | undefined;
  search?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export function useSkills(options: UseSkillsOptions = {}) {
  const query: WorkflowQuery = {
    usageType: 'skill',
    ...(options.status !== undefined ? { status: options.status } : {}),
    ...(options.search !== undefined ? { search: options.search } : {}),
    ...(options.page !== undefined ? { page: options.page } : {}),
    ...(options.limit !== undefined ? { limit: options.limit } : {}),
    sortBy: 'updatedAt',
    sortOrder: 'desc',
  };
  return useWorkflows(query);
}
